export default {
  fa: require("./fa"),
};
